<si-newton-section>

  <app-navigation [currentSectionForm]=resultOverviewForm></app-navigation>
  <form [formGroup]="resultOverviewForm" class="col-md-12" style="align-items: center;">

    <tabset>
      <tab heading="Cost Overview">
        <app-cost-overview [parentForm]="resultOverviewForm" [costOverviewData]="costOverviewData"(openHelpModal)="openHelpModal($event)"></app-cost-overview>

      </tab>

      <tab heading="Price Overview">
        <app-price-overview [parentForm]="resultOverviewForm" [priceOverviewData]="priceOverviewData" (openHelpModal)="openHelpModal($event)"></app-price-overview>

      </tab>
    </tabset>
    <app-result-file [parentForm]="resultOverviewForm" (openHelpModal)="openHelpModal($event)"></app-result-file>
  </form>
</si-newton-section>
